import actionConsts from './../../constants/actions';

const timeData = (state = {}, action = {}) => {
    switch (action.type) {
        case actionConsts.GET_CURRENT_TIME:
            return action.payload.timeLeft ? { ...state, timeLeft: action.payload.timeLeft } : { ...state, timeLeft: 0 };
        case actionConsts.GET_TOTAL_TIME:
            return { ...state, totalTime: action.payload };
        case actionConsts.UPDATE_TIME_LEFT:
            return { ...state, timeLeft: action.payload };
        default:
            return state;
    }
};

export default timeData;


// WEBPACK FOOTER //
// /src/reducers/timer/index.js